import React, { useState } from 'react';
const faqs = [{
  q: 'Er det velegnet til begyndere?',
  a: 'Ja, metoden guider dig trin-for-trin.'
}, {
  q: 'Fungerer det på min mobil?',
  a: "Ja, alle PDF'er er optimeret til tablet, mobil og PC."
}, {
  q: 'Hvordan modtager jeg materialet?',
  a: 'Du får et download-link direkte i din e-mail straks efter købet.'
}, {
  q: 'Er der en rigtig garanti?',
  a: 'Ja, 7 dages fuld tilfredshed eller pengene retur.'
}, {
  q: 'Er det egnet, hvis jeg er nybegyndertræner?',
  a: 'Ja, det er designet til at starte fra bunden. Du åbner bindet, læser i 3 minutter, og går på banen med alt klar.'
}, {
  q: 'Kan jeg bruge det både i skolen og i klubben?',
  a: 'Ja. Materialet er tænkt til idrætstimer og klubtræning. Sessionerne kan tilpasses til 40, 60 eller 80 minutter.'
}, {
  q: 'Kræver det tidligere erfaring med håndbold for at bruge det?',
  a: 'Nej. Hver øvelse inkluderer mål, organisering af rummet, variationer og vigtige fokuspunkter. Det er et guidet system, trin-for-trin.'
}, {
  q: 'Vil jeg modtage fremtidige opdateringer?',
  a: 'Ja. Når du har købt, får du gratis adgang til fremtidige forbedringer og nye sessioner, som vi tilføjer til den komplette pakke.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-105">
          Ofte stillede spørgsmål (FAQ)
        </h2>

        <div className="space-y-4 mb-16" data-id="element-106">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(59,130,246,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-107">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-108">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-109">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-110">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-60 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-111">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-112">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-113">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" data-id="element-114"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-115">
            🚀 JA! JEG VIL OPGRADERE MIN KARRIERE NU
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-116">
            <span data-id="element-117">⚡ Øjeblikkelig adgang</span>
            <span data-id="element-118">•</span>
            <span data-id="element-119">🛡️ 7 dages garanti</span>
          </p>
        </div>
      </div>
    </section>;
}